import {
  k_one_hour,
  k_session_removed,
  k_get_wind_stats_error,
  k_delete_wind_stats_error,
  k_delete_tzips_error,
  k_delete_rigs_error,
  k_delete_session_error,
} from '../assets/colors'

const DoDeleteSession = async (session) => {
  const sessionId = session._id

  //find and delete wind stats used only by this session
  return await new Promise((resolve, reject) => {
    if (session.meteoStationId !== '') {
      const timeU = new Date(session.restrictedStartSession).getTime()
      const largeSessionStart = timeU - k_one_hour
      const largeSessionEnd =
        timeU + session.restrictedSessionDuration * 1000 + k_one_hour
      const balise_data = {
        start: largeSessionStart,
        end: largeSessionEnd,
        baliseId: session.meteoStationId,
      }
      const balise_url = '/api/windstat/getBetweenDates'
      const dc = decodeURIComponent(document.cookie)
      const sdc = dc.split('=')[1]
      const ws = sdc.split(';')[0]
      fetch(balise_url, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          authorization: 'ws ' + ws,
        },
        body: JSON.stringify(balise_data),
      })
        .then((response) => {
          response.json().then((stats) => {
            stats.forEach((stat) => {
              const data_stat = {
                meteoStationId: stat.stationId,
                timeU: stat.timeU,
                sessionId: session._id,
              }
              const url_stat = '/api/sessionWS/getSessionsForStat'
              const dc = decodeURIComponent(document.cookie)
              const sdc = dc.split('=')[1]
              const ws = sdc.split(';')[0]
              fetch(url_stat, {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json',
                  authorization: 'ws ' + ws,
                },
                body: JSON.stringify(data_stat),
              }).then((response) => {
                response.json().then((nb) => {
                  if (nb === 0) {
                    const del_url = '/api/windstat/deleteOneWindStat'
                    const del_data = {
                      timeU: stat.timeU,
                      sessionId: session._id,
                    }
                    fetch(del_url, {
                      method: 'post',
                      headers: {
                        'Content-Type': 'application/json',
                        authorization: 'ws ' + ws,
                      },
                      body: JSON.stringify(del_data),
                    })
                      .then((res) => {
                        console.log('wind stat supprimée ' + stat)
                      })
                      .catch((error) => {
                        console.log('Error deleting wind stat ' + stat, error)
                        resolve({
                          result: k_delete_wind_stats_error,
                          sessionId: session._id,
                        })
                      })
                  }
                })
              })
            })
          })
        })
        .catch((error) => {
          console.log(
            'error getting wind stats for session ' + session._id,
            error
          )
          resolve({ result: k_get_wind_stats_error, sessionId: session._id })
        })
    }
    // find and delete tzip for the session
    const url = '/api/tzip/deleteTZip'
    const data = { sessionId }

    fetch(url, {
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then((response) => {
        console.log('trkpts supprimés pour la session ' + sessionId)
        //find and delete rigs for the session
        const url = '/api/rig/deleteRigsForSession'
        fetch(url, {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        })
          .then((response) => {
            console.log('rigs supprimés pour la session ' + sessionId)
            //eventually delete session
            const url_del_session = '/api/sessionWS/deleteOneSessionWS'
            fetch(url_del_session, {
              method: 'post',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data),
            })
              .then((response) => {
                console.log('session, rigs et trkpts supprimés')
                resolve({
                  result: k_session_removed,
                  sessionId: session._id,
                })
              })
              .catch((error) => {
                console.log('delete session error ' + sessionId, error)
                resolve({
                  result: k_delete_session_error,
                  sessionId: session._id,
                })
              })
          })
          .catch((error) => {
            console.log('delete rigs error for session ' + sessionId, error)
            resolve({ result: k_delete_rigs_error, sessionId: session._id })
          })
      })
      .catch((error) => {
        console.log('delete tzip error for session ' + sessionId, error)
        resolve({ result: k_delete_tzips_error, sessionId: session._id })
      })
  })
}

export default DoDeleteSession
